import { memo, useCallback, useState, useEffect } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import ModalTemplateNode from "../../../pages/modals/workflow/modal-template-node";

const TemplateNode = (props) => {
    const [showModal, setShowModal]         = useState(false);
    const [statistic, setStatistic]         = useState(0)
    const [id, setID]                       = useState(-1)

    const [templateSelectData, setTemplateSelectData] = useState([])

    const reactFlowInstance                 = useReactFlow();

    useEffect(() => {
        const handleNodeProps = () => {
            const nodeInfo = props.data.nodeInfo;
            setStatistic(nodeInfo.statistic)
            setID(parseInt(nodeInfo.node))
            setTemplateSelectData(nodeInfo.templateSelectData)
        };
        handleNodeProps();
    }, [props.data]);

    const constas = useCallback(() => {
        reactFlowInstance.deleteElements({ nodes: [props] });
    }, [reactFlowInstance, props]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const copy = (e) => {
        e.stopPropagation()
        let _id  = window.getId()
        let _get = reactFlowInstance.getNodes()
        _get = _get.filter(_item => {
            return parseInt(_item.id) === parseInt(props.id)
        })[0]

        reactFlowInstance.setNodes((nds) => nds.concat( { 
            ...props,
            id       :_id,
            position : { x: _get.position.x, y: _get.position.y  + _get.height + 20},
            height   : _get.height,
            width    : _get.width,
            data     : {
                nodeInfo: {
                    node        : _id,
                    parentId    : -1, 
                    targetId    : -1,
                    template           : props.data.nodeInfo.template,
                    templateSelectData : props.data.nodeInfo.templateSelectData,
                    objectType  : 20                   
                }
            }
        }))
    }

    if (showModal) {
        return (
            <>
                <ModalTemplateNode
                    nodeId={props.id}
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    nodeData={props.data.nodeInfo}
                ></ModalTemplateNode>
            </>
        );
    }

    return (
        <>
            <div className="rfnode rfnode-template d-flex flex-column justify-content-center align-items-center h-100 bg-light box-shadow" onClick={(e) => setShowModal(true)}>
                <div className="rfnode-title">#{id} Template</div>
                <div  style={{ maxWidth: "200px", borderRadius: "5px", padding: "4px", width:"140px" }}>
                        {templateSelectData.length <= 0 ? (
                            <div style={{fontSize:"6px", padding:"10px", background:"#58151cc1", borderRadius:"5px", margin:"5px 5px", color:"#fff"}}>
                                <span>Aqui você adiciona os itens da sua lista </span>
                            </div>
                        ) : (
                            <div style={{fontSize:"6px", padding:"10px", background:"#58151cc1", borderRadius:"5px", margin:"5px 5px", color:"#fff"}}>
                                <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                                    <span style={{fontWeight:"bold",fontSize:"6px"}}>
                                        Template
                                    </span>
                                    <span style={{fontSize:"8px"}}>
                                        {templateSelectData.name.toString().toUpperCase()}
                                    </span>
                                </div>
                                <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
                                    <span style={{fontWeight:"bold",fontSize:"6px"}}>
                                        Categoria
                                    </span>
                                    <span style={{fontSize:"8px"}}>
                                        {templateSelectData.category.toString().toUpperCase()}
                                    </span>
                                </div>
                            </div>
                        )
                    }
           
               
                    <div style={{display:"flex",fontSize:"8px", padding:"3px 5px", justifyContent:"space-between", width:"100%", borderTop:"1px dashed #58151c"}}>
                        <div style={{display:"flex", gap:"5px"}} >
                            <div onClick={e => copy(e)} title="Copiar Ação" className="workflow-copy" >
                                <i className="fa fa-copy text-primary"></i>
                            </div>
                            <div onClick={() => constas()} title="Excluir Mensagem" className="workflow-delete" >
                                <i className="fa fa-trash text-danger"></i>
                            </div>
                        </div>
                        <div title="Número de vezes que o lead passou pela ação">
                            <span style={{fontSize:"10px", color:"#58151c"}}>{statistic || ''}</span>
                        </div>
                    </div>
                </div>
            </div>
            <Handle type="source" position={Position.Bottom} id='node-bottom1' />
            <Handle type="target" position={Position.Top}    id='node-bottom2' />
            <Handle type="target" position={Position.Left}   id='node-bottom3' />
            <Handle type="source" position={Position.Right}  id='node-bottom4' />
        </>
    );
};

export default memo(TemplateNode);
